import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouReceive() {
  return <section className="bg-transparent relative overflow-hidden" data-id="element-370" data-mp="973vunyevg4e">
      <div className="w-full" data-id="element-371" data-mp="98ono5tcckyk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full flex flex-col" data-id="element-372" data-mp="mxyxbf6kyuxy">
          <img src="https://cdn.magicpatterns.com/uploads/gPL8YTNRzFKds1Dk5ZqoAf/0d025a70-63e8-4f8d-b616-756e5ee05da2.webp" alt="¿Qué vas a Recibir? - Parte 1" className="w-full h-auto block" data-id="element-373" data-mp="wuv9buvotz79" />
          <img src="https://cdn.magicpatterns.com/uploads/tmVYXaz7312ZYsr9y2V7MC/463277a0-53ba-411e-a4fe-950f008b5e8c.webp" alt="¿Qué vas a Recibir? - Parte 2" className="w-full h-auto block" data-id="element-374" data-mp="15vtbe7mkfwn7" />
        </motion.div>
      </div>
    </section>;
}